// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1tOhC","box":"WorkspacesBox_box__2xyD5","node":"WorkspacesBox_node__209AK"};